import { SxProps } from '@mui/material';
import { black, blue, grey8 } from 'app/components/ThemeProvider/colors';

export const countBox: SxProps = {
  display: 'flex',
  mt: '28px',
};

export const infoTextTimer: SxProps = {
  mr: '5px',
  color: grey8,
  fontSize: '18px',
  fontFamily: 'Yelo',
};

export const timer: SxProps = {
  color: black,
  fontSize: '18px',
  fontFamily: 'Yelo',
};

export const resent: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '15px',
  fontWeight: '400',
  color: blue,
  mt: '28px',
  cursor: 'pointer',
  p: 0,
};
